export const GQT_ACCOUNTING = 'GQT_ACCOUNTING';
export const GQT_AIR = 'GQT_AIR';
export const GQT_CRUISE = 'GQT_CRUISE';
export const GQT_INCENTIVE = 'GQT_INCENTIVE';
export const GQT_ADMIN = 'GQT_SADMIN';
export const GQT_COORDINATOR = 'GQT_COORDINATOR';
export const GQT_REVENUE = 'GQT_REVENUE';
export const GQT_COMMERCIAL = 'GQT_COMMERCIAL';
export const GQT_SUPERVISOR = 'GQT_SUPERVISOR';
export const GQT_MARKETING = 'GQT_MARKETING';
export const GQT_SUPPORT = 'GQT_SUPPORT';
export const GQT_ASM = 'GQT_ASM';
export const GQT_TAGENT = 'GQT_TAGENT';
export const GQT_ALL = [GQT_ACCOUNTING, GQT_AIR, GQT_CRUISE, GQT_INCENTIVE, GQT_ADMIN, GQT_COORDINATOR, GQT_REVENUE, GQT_COMMERCIAL, GQT_SUPERVISOR, GQT_MARKETING, GQT_SUPPORT, GQT_ASM, GQT_TAGENT];
